import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleNavClick = (path, event) => {
        if (location.pathname === path) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
        closeMenu();
    };

    const navigationItems = [
        { path: "/", label: "Home" },
        { path: "/about-river", label: "About River" },
        { path: "/advisory", label: "Advisory" },
        { path: "/investments", label: "Investments" },
        { path: "/operations", label: "Operations" },
        { path: "/portfolio", label: "Portfolio" },
    ];

    return (
        <>
            <header className="header">
                <div className="header-container container">
                    <Link to="/" className="logo" onClick={closeMenu}>
                        <svg
                            preserveAspectRatio="xMidYMid meet"
                            data-bbox="0.93 0 253.9 76.3"
                            viewBox="0.93 0 253.9 76.3"
                            xmlns="http://www.w3.org/2000/svg"
                            data-type="color"
                            role="presentation"
                            aria-hidden="true"
                            aria-label=""
                        >
                            <g>
                                <path
                                    fill="#179dca"
                                    d="M254.83 59.2a8.1 8.1 0 1 1-16.2 0 8.1 8.1 0 0 1 16.2 0"
                                    data-color="1"
                                ></path>
                                <path
                                    d="M.93 0v27.2h1.1c2.4 0 3.4-.5 4.9-1.1 1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8v7.2c-2.4 0-3.4.5-4.9 1.1-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8H.93v8.3h1.1c2.4 0 3.4-.5 4.9-1.1 1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8V47c-2.4 0-3.4.5-4.9 1.1-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8H.93v8.3h1.1c2.4 0 3.4-.5 4.9-1.1 1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8v7.2c-2.4 0-3.4.5-4.9 1.1-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8H.93v10.9h76.3V0z"
                                    fill="#179dca"
                                    data-color="1"
                                ></path>
                                <path
                                    d="M100.75 28.54h7.2v5.84h.16q.72-1.515 1.92-2.76c.8-.83 1.69-1.53 2.68-2.12s2.07-1.05 3.24-1.4 2.35-.52 3.52-.52 2.24.16 3.2.48l-.32 7.76c-.59-.16-1.17-.29-1.76-.4s-1.17-.16-1.76-.16c-3.52 0-6.21.99-8.08 2.96s-2.8 5.04-2.8 9.2v19.04h-7.2z"
                                    fill="#000000"
                                    data-color="2"
                                ></path>
                                <path
                                    d="M126.03 14.94q0-2.16 1.56-3.72c1.56-1.56 2.28-1.56 3.72-1.56s2.68.52 3.72 1.56 1.56 2.28 1.56 3.72-.52 2.68-1.56 3.72-2.28 1.56-3.72 1.56-2.68-.52-3.72-1.56-1.56-2.28-1.56-3.72m1.68 13.6h7.2v37.92h-7.2z"
                                    fill="#000000"
                                    data-color="2"
                                ></path>
                                <path
                                    d="M138.59 28.54h8.32l11.36 29.04 10.88-29.04h7.68l-14.88 37.92h-7.92z"
                                    fill="#000000"
                                    data-color="2"
                                ></path>
                                <path
                                    d="M184.43 50.14c0 1.65.36 3.16 1.08 4.52s1.67 2.52 2.84 3.48 2.53 1.71 4.08 2.24 3.15.8 4.8.8c2.24 0 4.19-.52 5.84-1.56s3.17-2.41 4.56-4.12l5.44 4.16c-4 5.17-9.6 7.76-16.8 7.76-2.99 0-5.69-.51-8.12-1.52s-4.48-2.41-6.16-4.2-2.97-3.89-3.88-6.32-1.36-5.05-1.36-7.88.49-5.45 1.48-7.88 2.35-4.53 4.08-6.32 3.8-3.19 6.2-4.2 5.01-1.52 7.84-1.52c3.36 0 6.2.59 8.52 1.76s4.23 2.71 5.72 4.6 2.57 4.03 3.24 6.4 1 4.79 1 7.24v2.56zm22.72-5.76c-.05-1.6-.31-3.07-.76-4.4a9.6 9.6 0 0 0-2.04-3.48c-.91-.99-2.04-1.76-3.4-2.32s-2.95-.84-4.76-.84-3.37.33-4.84 1-2.71 1.53-3.72 2.6-1.8 2.25-2.36 3.56-.84 2.6-.84 3.88z"
                                    fill="#000000"
                                    data-color="2"
                                ></path>
                                <path
                                    d="M220.11 28.54h7.2v5.84h.16q.72-1.515 1.92-2.76c.8-.83 1.69-1.53 2.68-2.12s2.07-1.05 3.24-1.4 2.35-.52 3.52-.52 2.24.16 3.2.48l-.32 7.76c-.59-.16-1.17-.29-1.76-.4s-1.17-.16-1.76-.16c-3.52 0-6.21.99-8.08 2.96s-2.8 5.04-2.8 9.2v19.04h-7.2z"
                                    fill="#000000"
                                    data-color="2"
                                ></path>
                            </g>
                        </svg>
                    </Link>

                    <button
                        className={`hamburger ${isMenuOpen ? "active" : ""}`}
                        onClick={toggleMenu}
                        aria-label="Toggle navigation menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </header>

            {/* Flyout Navigation */}
            <nav className={`flyout-nav ${isMenuOpen ? "open" : ""}`}>
                <div className="flyout-header">
                    <button
                        className="right close-button"
                        onClick={closeMenu}
                        aria-label="Close navigation menu"
                    >
                        <i className="fa-regular fa-xmark"></i>
                    </button>
                </div>

                <div className="flyout-content">
                    <ul className="nav-links">
                        {navigationItems.map((item) => (
                            <li key={item.path}>
                                <Link
                                    to={item.path}
                                    className={
                                        location.pathname === item.path ? "current-page" : ""
                                    }
                                    onClick={(event) => handleNavClick(item.path, event)}
                                >
                                    {location.pathname === item.path && (
                                        <i className="fa-solid fa-arrow-right"></i>
                                    )}
                                    <span>{item.label}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>

            {/* Overlay */}
            {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
        </>
    );
};

export default Header;
